import { APIRuntimeBuilder } from '@cian/mf-registry/browser';
import { ESearchType } from 'browser/utils';
import { TReduxStore } from 'shared/types/redux';
import { handleClickSearchSuggestion } from './handleClickSearchSuggestion';
import { handleSetJsonQuery } from './handleSetJsonQuery';
import { disablePlaceholder } from 'shared/actions/placeholderDisabled';
import { handleSetView } from './handleSetView';
import { ESearchBlockView } from 'shared/types/searchBlockView';

export function buildAPIRuntime(store: TReduxStore): APIRuntimeBuilder {
  return [
    {
      path: '/v1/set-filter-json-query',
      handler: async (data: { jsonQuery: object }) => {
        return handleSetJsonQuery(store, data);
      },
    },
    {
      path: '/v1/click-search-suggestion',
      handler: async (data: { type: ESearchType }) => {
        return handleClickSearchSuggestion(store, data);
      },
    },
    {
      path: '/v1/set-view',
      handler: async (data: { view: ESearchBlockView }) => {
        return handleSetView(store, data);
      },
    },
    {
      path: '/v1/disable-placeholders',
      handler: async () => {
        return store.dispatch(disablePlaceholder());
      },
    },
  ];
}
